package com.downdogapp.client.controllers

import com.downdogapp.client.MANIFEST
import com.downdogapp.client.Strings
import com.downdogapp.client.ViewController
import com.downdogapp.client.api.AppType.*
import com.downdogapp.client.api.FeedbackType.PRACTICE_FEEDBACK
import com.downdogapp.client.controllers.playback.PlaybackViewController
import com.downdogapp.client.controllers.start.HistoryPage
import com.downdogapp.client.controllers.start.StartViewController
import com.downdogapp.client.singleton.App
import com.downdogapp.client.singleton.HistoryUtil
import com.downdogapp.client.views.PostPracticeView

class PostPracticeViewController(private val playbackViewController: PlaybackViewController,
                                 private val requestReview: Boolean = false) : ViewController() {

  private val songsController = playbackViewController.songsController
  private val sequenceId = playbackViewController.sequence.sequenceId

  val message = playbackViewController.sequence.postPracticeMessage
  val showSongsRow get() = songsController.getSongsPlayed().isNotEmpty()
  val showFavoriteRow
    get() = MANIFEST.displayFavoritesPage
            && !HistoryUtil.isFavorite(sequenceId)
  val showPoseList =
    MANIFEST.showPosesOnTimeline
    && playbackViewController.sequence.poses.any { it.name != null }

  val poseListTitle
    get() = when (App.appType) {
      ORIGINAL, INTRO, PRENATAL -> Strings.POSE_LIST
      HIIT, BARRE, SEVEN, PILATES -> Strings.EXERCISE_LIST
      MEDITATION, RUNNING, BREATHING -> ""
    }

  override val view = PostPracticeView(this)

  override fun onViewBecameVisible() {
    songsController.setOnSongUpdated(::updateSongAttribution)
    updateSongAttribution()

    App.setupPlaybackControls(
      onPlay = { playbackViewController.play() },
      onPause = { playbackViewController.pause() },
      onChangePlaybackPosition = null,
      onSkipForward = null,
      onSkipBackward = null
    )
    if (requestReview) {
      App.requestReview()
    }

    StartViewController.handleMessageResponse(
      response = playbackViewController.sequence.postPracticePopUp,
      feedbackType = PRACTICE_FEEDBACK,
      sequenceId = sequenceId,
      sequenceTime = playbackViewController.sequenceLength
    )
  }

  override fun onPopped() {
    App.requestNotificationsAuthorization()
  }

  private fun updateSongAttribution() {
    view.updateSongAttribution(songsController.songAttribution)
  }

  fun saveClicked() {
    view.showSpinner()
    logEvent(
      "save_practice",
      mapOf(
        "sequenceId" to sequenceId,
        "from" to "post practice"
      )
    )
    HistoryUtil.updateSequenceFavorite(sequenceId, true) { success ->
      view.refreshView()
      view.hideSpinner()
      if (success) {
        App.alert(message = Strings.PRACTICE_SAVED_CONFIRMATION)
        StartViewController.goToPage(HistoryPage)
      } else {
        App.alertNoInternet()
      }
    }
  }

  fun feedbackClicked() {
    App.pushViewController(
      MessageViewController(
        message = MANIFEST.practiceFeedbackMessage!!,
        feedbackType = PRACTICE_FEEDBACK,
        sequenceId = sequenceId,
        sequenceTime = playbackViewController.sequenceLength
      )
    )
  }

  fun playlistClicked() {
    App.pushViewController(
      PlaylistViewController(songs = songsController.getSongsPlayed())
    )
  }

  fun poseListClicked() {
    App.pushViewController(
      PoseListViewController(
        title = poseListTitle,
        unfilteredItems = playbackViewController.sequence.poses
      )
    )
  }

  fun shareClicked() {
    App.shareSequence(sequenceId)
  }

  fun membershipClicked() {
    App.goToPurchase()
  }

  override fun onBackClicked() {
    playbackViewController.exitToStartScreen()
  }
}
